module.exports = __webpack_public_path__ + "images/emoji/police_car.04e384ab1077d064c357.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/police_car.png
// module id = 993x
// module chunks = 1